import { render, staticRenderFns } from "./MetatdataList.vue?vue&type=template&id=977f2c3e"
import script from "./MetatdataList.vue?vue&type=script&lang=js"
export * from "./MetatdataList.vue?vue&type=script&lang=js"
import style0 from "./MetatdataList.vue?vue&type=style&index=0&id=977f2c3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports